const noError = {code: 0, message: 'no error'};
const unauthorized = {code: 1000, message: 'unauthorized'};
const authorized = {code: 1001, message: 'authorized'};
const noPermission = {code: 1002, message: 'no permission'};
const onlyDevelopment = {code: 1003, message: 'only development'};
const duplicated = {code: 1004, message: 'duplicated'};
const badRequest = {code: 1005, message: 'bad request'};
const emptyData = {code: 1006, message: 'empty data'};
const invalidParams = {code: 1007, message: 'invalid params'};
const unknownError = {code: 9000, message: 'unknown error'};

export default {
    noError,
    unauthorized,
    authorized,
    noPermission,
    onlyDevelopment,
    duplicated,
    badRequest,
    emptyData,
    invalidParams,
    unknownError,
};
